import React, { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";

//Common
import { Snackbar } from "../common/VFX-UI";

//App
import { OrganizationEmployeeViewModel } from "../../viewModels";
import { OrganizationEmployeeDto } from "../../app/model/api/types/dto";
import organizationApi from "../../app/model/api/organizationApi";
import EmployeeForm from "./EmployeeForm";
import { EmployeeContext } from "./EmployeeContainer";
import { EMPTY_GUID } from "../../utility/constants/constants";
import { apiErrorMessage } from "../../utility/lib/error";
import { OrganizationEmployeeFormContainerProps } from "../../types/organizationEmployee";
import { SnackbarState } from "../../types";
import { employeeStatus } from "./constants";

export const EmployeeFormContainer: React.FC<
  OrganizationEmployeeFormContainerProps
> = (props) => {
  const { onClose, onShowSuccess } = props;
  const employeeContext = useContext(EmployeeContext);

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const successMessage = employeeContext?.id
    ? "Employee updated"
    : "New Employee added";

  const onShowErrorSnackbar = (errorMessage: string) => {
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });
  };

  const onCloseSnackbar = () => {
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });
  };

  const { status, mutate } = useMutation<void, Error, OrganizationEmployeeDto>({
    mutationFn: async (payload: OrganizationEmployeeDto) => {
      const response = await organizationApi.saveEmployee(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess(successMessage);
      }
    },
  });

  const handleOnSubmit = async (values: OrganizationEmployeeViewModel) => {
    const employee: OrganizationEmployeeDto = values.toDto();
    mutate(employee);
  };
  
  const initialValues = employeeContext?.id
    ? new OrganizationEmployeeViewModel(
        employeeContext.data?.id ?? null,
        employeeContext.data?.firstName ?? null,
        employeeContext.data?.lastName ?? null,
        employeeContext.data?.emailAddress ?? null,
        employeeContext.data?.personnelNumber ?? null,
        employeeContext.data?.workPersonnelArea ?? null,
        employeeContext.data?.divisionName ?? null,
        employeeContext.data?.supervisorName ?? null,
        employeeContext.data?.domainLanId ?? null,

        employeeContext.data?.statusId !== null &&
        employeeContext.data?.statusId !== undefined
          ? [employeeContext.data?.statusId]
          : null,

        employeeContext.data?.typeId !== null &&
        employeeContext.data?.typeId !== undefined
          ? [employeeContext.data?.typeId]
          : null,
        employeeContext.data?.organizationUnitName ?? null,
        employeeContext.data?.organization ?? null,
        employeeContext.data?.mi ?? null,
        employeeContext.data?.stepUpEnrollmentDate
          ? employeeContext.data?.stepUpEnrollmentDate?.toString().split("T")[0]
          : null,
        employeeContext.data?.leadershipEnrollmentDate
          ? employeeContext.data?.leadershipEnrollmentDate?.toString().split("T")[0]
          : null,
        employeeContext.data?.isActive ?? null
      )
    : new OrganizationEmployeeViewModel(
        EMPTY_GUID,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        [employeeStatus.active],
        [],
        "",
        null,
        "",
        null,
        null,
        true
      );

  return (
    <>
      <EmployeeForm
        initialVal={initialValues}
        status={status}
        handleOnSubmit={handleOnSubmit}
        onClose={onClose}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
};
